import { z } from "zod";

import { IssueTypeEnum } from "../../__generated__/graphql";
import type { PackageIssueKind } from "./package-issue.types";

interface PackageIssueContent {
  title: string;
  description: string;
  issueType: IssueTypeEnum;
}

export const PACKAGE_ISSUE_CONTENT: Record<PackageIssueKind, PackageIssueContent> = {
  "edit-address": {
    title: "Edit Address",
    description:
      "Please provide us a reason to modify your package address, and fill the comment to describe the reason.",
    issueType: IssueTypeEnum.PackageUpdateAddress,
  },
  "modify-plan": {
    title: "Modify Plan",
    description:
      "Please provide us a reason to modify your package address, and fill the comment to describe the reason.",
    issueType: IssueTypeEnum.PackageUpdate,
  },
  "cancel-package": {
    title: "Cancel package",
    description: "One more step to cancel your plan, could you let us know the reason.",
    issueType: IssueTypeEnum.PackageTermination,
  },
};

export const packageIssueSchema = z.object({
  reason: z.string().min(1, { error: "Reason is a required field" }),
  comment: z.string().min(1, { error: "Comment can't be blank, please enter a comment" }),
});

export type PackageIssueFormValues = z.infer<typeof packageIssueSchema>;

export const emptyPackageIssueValues: PackageIssueFormValues = { reason: "", comment: "" };
